import { Theme } from "@astryxdesign/core";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router/dom";

// Fonts are self-hosted and linked by build.ts, not imported — see
// public/fonts.css for why. Astryx's component styles come first, so the
// page's own sheet wins where the two meet.
import "@astryxdesign/core/astryx.css";
import "./styles.css";
import { router } from "./router";
import { hireosTheme } from "./theme/hireos";

// The dev server serves index.html as it is, with no fonts link in it, so
// link the same sheet here when build.ts hasn't.
if (!document.querySelector('link[href="/fonts.css"]')) {
  const fonts = document.createElement("link");
  fonts.rel = "stylesheet";
  fonts.href = "/fonts.css";
  document.head.append(fonts);
}

const root = document.getElementById("root");
if (!root) throw new Error("Root element #root not found");

createRoot(root).render(
  <StrictMode>
    <Theme theme={hireosTheme} mode="light">
      <RouterProvider router={router} />
    </Theme>
  </StrictMode>,
);
